import React, { useState } from "react";
import ModalPartner from "./ModalPartner";
import ModalUpdateSuccess from "./ModalUpdateSuccess";
import ModalUpdatePartner from "./ModalUpdatePartner";
import ModalCancelSuccess from "./ModalCancelSuccess";
import ModalAddPartner from "./ModalAddPartner";
import ModalSubmit from "./ModalSubmit";
import ModalCancel from "./ModalCancel";
import ModalUpdateEntry from "./ModalUpdateEntry";

const ModalManager = ({ entry, openModal, closeModal, modal }) => {
  // list partner display
  const [list, setList] = useState(entry.partnerships);
  const [promotionSet, setPromotionSet] = useState();
  const [partnerInfo, setPartnerInfo] = useState(null);

  const closeModalManager = () => {
    closeModal();
    setList(entry.partnerships);
  };

  const foundIndex = (list, partner) => {
    const index = list.findIndex(
      (p) => JSON.stringify(p) === JSON.stringify(partner)
    );
    return index;
  };

  // add partner
  const handleAddPartner = (partner) => {
    setList([...list, partner]);
    openModal("modal-partner");
  };

  // update partner
  const handleUpdatePartner = (partner, partnerUpdate) => {
    const { promotion_set_id, ..._partner } = partner;
    const newArr = list.map((p) => {
      const { promotion_set_id, ..._p } = p;
      // set action
      let action = partner.action === 0 ? 0 : partner.action !== 2 ? 1 : 2;
      // cập nhật cho cùng 1 partner nếu tham gia nhiều promotion_set
      if (JSON.stringify(_p) === JSON.stringify(_partner)) {
        return { ...partnerUpdate, action, promotion_set_id };
      }
      return p;
    });
    setList(newArr);
  };

  // delete partner
  const handleDeletePartner = (partner) => {
    let newArr = [...list];
    if (partner.action === 0) {
      setList(
        newArr.filter(
          (item) => JSON.stringify(item) !== JSON.stringify(partner)
        )
      );
    } else {
      newArr[foundIndex(list, partner)] = { ...partner, action: 2 };
      setList(newArr);
    }
  };

  return (
    <>
      <ModalPartner
        open={modal === "modal-partner"}
        openFn={openModal}
        closeFn={closeModalManager}
        entry={entry}
        list={list}
        handleDeletePartner={handleDeletePartner}
        setPromotionSet={setPromotionSet}
        setPartnerInfo={setPartnerInfo}
      />
      <ModalAddPartner
        open={modal === "modal-add-partner"}
        openFn={openModal}
        promotionSet={promotionSet}
        handleAddPartner={handleAddPartner}
        entry={entry}
      />
      <ModalUpdatePartner
        open={modal === "modal-update-partner"}
        openFn={openModal}
        partnerInfo={partnerInfo}
        handleUpdatePartner={handleUpdatePartner}
        setPartnerInfo={setPartnerInfo}
        entry={entry}
        list={list}
      />
      <ModalSubmit
        open={modal === "modal-submit"}
        openFn={openModal}
        entry={entry}
        partnership={list}
      />
      <ModalUpdateSuccess
        open={modal === "modal-update-success"}
        closeFn={closeModal}
        entry={entry}
        partnership={list}
      />
      <ModalCancel
        open={modal === "modal-cancel"}
        openFn={openModal}
        closeFn={closeModal}
        entry={entry}
      />

      <ModalCancelSuccess
        open={modal === "modal-cancel-success"}
        closeFn={closeModal}
        entry={entry}
      />
      <ModalUpdateEntry
          open={modal === "modal-update-entry"}
          closeFn={closeModal}
        />
    </>
  );
};

export default ModalManager;
